import PropTypes from "prop-types";
import React, { useState } from "react";

// material
import { alpha, styled } from "@mui/material/styles";
import {
  Box,
  Stack,
  AppBar,
  Toolbar,
  Grid,
  Button,
  Typography,
  Container,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import AccountPopover from "./AccountPopover";
import useMediaQuery from "@mui/material/useMediaQuery";
import { MHidden } from "../../components/@material-extend";
import { parseEmail } from "../../utils/tableFunctions";
import { APP_USER_SESSION } from "../../constant/AppConstants";
import * as StorageUtils from "../../utils/storageUtils";
import ProductUpdateDrawer from "../../components/Product-Update/Drawers/ProductUpdateDrawer";

// ----------------------------------------------------------------------

const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: "none",
  backdropFilter: "blur(6px)",
  // WebkitBackdropFilter: "blur(6px)", // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 1),
  // backgroundColor: "transparent",
  [theme.breakpoints.up("lg")]: {
    // width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
    width: `100%`,
    alignItems: "center",
    paddingLeft: 280
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  // width: "70%",
  // alignItems: "center",
  [theme.breakpoints.up("lg")]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
};

export default function DashboardNavbar({ onOpenSidebar }) {
  const hidden = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  const userSession = StorageUtils.getParsedValue(APP_USER_SESSION);

  const [openDrawer, setOpenDrawer] = useState(false);

  return (
    <Container>
      <ToolbarStyle>
        <MHidden width="lgUp">
          <Button onClick={onOpenSidebar}>
            <MenuIcon sx={{ mr: 1, color: "text.primary" }} />
          </Button>
        </MHidden>

        <Box sx={{ width: 5 }} />
        <Stack
          direction="row"
          alignItems="center"
          style={{ marginLeft: "auto", marginRight: "0" }}
        >
          {hidden ? null : (
            <Grid
              container
              style={{
                alignItems: "center",
                textAlign: "center",
              }}
            >
              <Grid item style={{ alignItems: "center" }}>
                <Typography
                  variant="body"
                  color="primary.main"
                  fontWeight="600"
                  textAlign="center"
                  sx={{ mr: 1 }}
                >
                  Hello, {parseEmail(userSession.user.email)}
                </Typography>
              </Grid>
              {/* <Grid item>
                <Typography variant="body" color="primary.main" fontWeight="600">
                  <Label variant="ghost" color="primary">
                    {details.role.role}
                  </Label>
                </Typography>
              </Grid> */}
            </Grid>
          )}
          <AccountPopover />
        </Stack>
      </ToolbarStyle>
      <ProductUpdateDrawer open={openDrawer} setOpenDrawer={setOpenDrawer} />
    </Container>
  );
}
